import {
  geoToAddress,
  pricingGeographyId,
  splitName,
  operationalDetailsToAddress,
  emptyAddress,
} from "../utils/addressMapper";

export const buildKycFromKycResponse = (data, verificationThrough) => {
  const geo = data?.geography_info;
  const address = geoToAddress(geo);
  return {
    ...splitName(data?.name || data?.full_name),
    gender: data?.gender || null,
    date_of_birth: data?.date_of_birth || data?.dob || null,
    company_name: null,
    company_gstin: null,
    pancard_no: data?.pan || data?.pancard_no || null,
    registered_address: geo ? address : null,
    verified: true,
    verification_data: {
      session_id: data?.session_id || data?.transaction_id || null,
      verification_through: verificationThrough,
    },
    pricing_geography_id: pricingGeographyId(geo),
  };
};

export const buildKycFromManual = (formData) => ({
  ...splitName(formData?.full_name || formData?.name),
  gender: formData?.gender || null,
  date_of_birth: formData?.date_of_birth || formData?.dob || null,
  company_name: null,
  company_gstin: null,
  pancard_no: formData?.pan || formData?.pan_number || null,
  operational_address: emptyAddress(),
  registered_address: null,
  verified: false,
  verification_data: null,
  pricing_geography_id: null,
});

export const buildKycFromOperational = (od, personName) => {
  const address = operationalDetailsToAddress(od);
  return {
    ...splitName(personName),
    gender: null,
    date_of_birth: null,
    company_name: od?.firm_name || null,
    company_gstin: od?.gst_number || null,
    pancard_no: od?.pan_number || null,
    operational_address: address,
    registered_address: address,
    verified: false,
    verification_data: null,
    pricing_geography_id: null,
  };
};
